import React from 'react';
import { useParams } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
import DepartmentList from './DepartmentList';

const GroupDepartments = () => {
    const { groupId } = useParams();

    return (
        <div className="min-vh-100 d-flex flex-column">
            <Header />
            
            <div className="container-fluid p-3 flex-grow-1" style={{ marginTop: '80px', marginBottom: '60px' }}>
                <DepartmentList />
            </div>

            <Footer />
        </div>
    );
};

export default GroupDepartments;